import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Article3() {
  const { t } = useTranslation();
  
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="article-page">
      <div className="article-header" data-aos="fade-up">
        <h1 className="article-title">{t("articles.article3.title")}</h1>
      </div>
      
      <div className="article-content" data-aos="fade-up">
        <div className="article-images article-single-image">
          <img 
            src="/images/article3-img1.jpeg" 
            alt="University of Arkansas Timber Center" 
            className="article-image"
            data-aos="zoom-in"
          />
        </div>
        
        <div className="article-text" data-aos="fade-up">
          <p>{t("articles.article3.paragraph1")}</p>
          <p>{t("articles.article3.paragraph2")}</p>
          <p>{t("articles.article3.paragraph3")}</p>
        </div>
      </div>
    </div>
  );
}

